<template>
    <div>

      <el-form :model="form" :rules="rules" ref="form" label-width="150px">
        不需要测
          <el-form-item label="上传文件" prop="path">
              <el-upload  action="" :before-upload="beforeUpload"   :show-file-list="false" :http-request="handleHttpRequest">
              <!-- <el-upload  action="" :before-upload="beforeUpload"   :show-file-list="false"  :http-request="handleHttpRequest"> -->
                  <el-button size="small" type="primary">点击上传</el-button>
                  <span>{{this.form.path}}</span>
              </el-upload>
          </el-form-item>
           <el-button type="primary">主要按钮</el-button>
      </el-form>
      <br>
  </div>
</template>
<script>
import axios from "axios";
export default {
    data() {
      return {
        rules: {
            path: [ { required: true, message: "请选择文件", trigger: "blur" } ]
        },
        form: {
            name: undefined,
            version: undefined,
            type: undefined,
            path: undefined
        }
      }
    },
    methods: {
      handleHttpRequest(fileDatas){
        var fd = new FormData();
        fd.append("file", fileDatas.file);
        fd.append("name", "111111");
        fd.append("sd", "12222");
        fd.append("dfdfdf", "55555555");
        let config = {
          headers: {
              'Content-Type': 'multipart/form-data'
          }
        }
        axios.post("http://192.168.1.89:3030/DepartMent/UploadFile", fd, config).then(response => { 

        });
      },
      beforeUpload(file) {

      }
    }
}
</script>

<style>

</style>

